// Fernzugriff im Browser: Adressen und Nachrichtenformat der SSH-Sitzung.
//
// Der Datenstrom läuft binär über den WebSocket, damit jedes Byte des Geräts
// unverändert im Terminal landet. Nur Steuernachrichten sind JSON.

export interface TerminalControl {
  type: 'ready' | 'error' | 'closed' | 'resize'
  message?: string
  session_id?: string
  host_key?: string
  device?: string
  address?: string
  cols?: number
  rows?: number
}

/** Adresse des Terminal-WebSockets für ein Gerät. */
export function terminalSocketUrl(deviceId: string, cols: number, rows: number): string {
  const scheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const size = `?cols=${Math.max(1, Math.floor(cols))}&rows=${Math.max(1, Math.floor(rows))}`
  return `${scheme}//${window.location.host}/api/devices/${encodeURIComponent(deviceId)}/ssh${size}`
}

/** Liest eine Steuernachricht; alles Unverständliche wird verworfen. */
export function parseControl(raw: string): TerminalControl | null {
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    const message = parsed as TerminalControl
    if (typeof message.type !== 'string') return null
    return message
  } catch {
    return null
  }
}

/** Nachricht an den Server, dass sich die Terminalgröße geändert hat. */
export function resizeMessage(cols: number, rows: number): string {
  return JSON.stringify({ type: 'resize', cols, rows })
}

/** Die Kennfarbe eines Kunden, wie sie der Kundenwechsler vergibt. */
export function customerColor(color: string | undefined): string {
  return `var(--${color && /^cust-[1-6]$/.test(color) ? color : 'cust-1'})`
}
